var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.activeModule === 'all-ghgi')?_c('all-ghgi'):_vm._e(),(_vm.activeModule === 'ghgi-comparison')?_c('ghgi-comparison'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }